/**
 * Created by Languagenut on 16/04/2019.
 */

import React  from 'react';

import {ProgressBar} from 'react-bootstrap'
import ClassesService from '../../services/classes-service.js';
import ClassStore from '../../store/classes-store.js';
import Constants from '../../constants.js';
import Translation from '../../store/internationalization-store.js';
import Table from '../../components/general_table.js';

export default class Assignments extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            toggle:false,
            assignments:[],
            archivedLanguages:[],
            hasLoaded:false
        };
    }

    componentWillMount(){

        ClassStore.on(Constants.GET_STUDENT_ASSIGNMENTS , ()=>{
            var stuff = ClassStore.studentAssignments;
            this.setState({
                assignments:ClassStore.studentAssignments|| [],
                archivedLanguages:[],
                hasLoaded:true
            })
        })
    }

    componentDidMount(){
        ClassesService.getStudentAssignments(this.props.studentUid);
    }

    renderProfileLink(cell, row){

        return <a href={"#/assignments/overview/"+row.id}>{cell}</a>
    }

    renderAvailability(cell, row){
        return <div>{(new Date(cell.replace(" ", "T"))).format('d-m-y')}</div>
    }

    isAvailible(cell, row){
        if (cell == 1) {
            return <div><label style={{width:"50%", margin:"auto"}} class="b-contain">
                    <input disabled={true} checked={true} type="checkbox"/>
                    <div class="b-input"></div>
                </label></div>
        }
        return <div><label style={{width:"50%", margin:"auto"}} class="b-contain">
                <input disabled={true} checked={false} type="checkbox"/>
                <div class="b-input"></div>
            </label></div>
    }

    totalStuff(cell, row){
        return row.completed + " / " + row.totalNum;
    }

    render(){

        if (!this.state.hasLoaded) {
            return <ProgressBar animated now={45}/>;
        }

        const columns = [
        {
            dataField: 'name',
            text: Translation.get(14 , 'Name'),
            hidden: true,
            sort:true,
            searchable: true,
        },{
             dataField: 'name',
             text: Translation.get(2008 , 'Assignment Name'),
             formatter: this.renderProfileLink.bind(this),
             sort:true,
             searchable: false,
         },{
             dataField: 'language',
             text: Translation.get(492 , 'Language'),
             formatter: (cell)=>{
                 return Translation.get(cell , 'Language')
             },
            searchable: false,
         },{
             dataField: 'due',
             text: Translation.get(12104 , 'Due Date'),
             align:'left',
            sort:true,
             formatter: this.renderAvailability.bind(this),
            searchable: false,
         },{
            dataField: 'average',
            text: Translation.get(693 , 'Average Score'),
            align:'left',
            sort:true,
            formatter: (cell)=>{
                return Math.round(cell) + "%";
            },
           searchable: false,
        }, {
            dataField: 'totalNum',
            text: Translation.get(772 , 'Completed'),
            align:'left',
            sort:true,
            formatter: this.totalStuff.bind(this),
           searchable: false,
        },{
            dataField: 'isRepeatable',
            text: Translation.get(12609 , 'Is Repeatable'),
            align:'left',
            sort:true,
            formatter: this.isAvailible.bind(this),
           searchable: false,
        }];

        return <div>
            <div>
                <Table hideDownload secondary={""} component={""} bordered={ true } key='id' data={this.state.assignments} columns={ columns } />
            </div>
        </div>
    }
}
